import { useState } from 'react';

export default function({onFilterChange}: {onFilterChange:Function})  {
	const [value, setValue] = useState("")

	function handleChange(e) {
		setValue(e.target.value)
		onFilterChange(e.target.value); // Update exposed function
	};

 	return <input type="search" value={value} onChange={handleChange} placeholder="Suche"/>
}

